/**
 * Set the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_LOADING = state => {
    state.loading = true
}

/**
 * Reset the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_LOADING = state => {
    state.loading = false
}

/**
 * Set the data on the state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const SET_DATA = (state, payload) => {
    state.data[payload.type] = payload.data
}

export default {
    SET_DATA,
    SET_LOADING,
    RESET_LOADING
}



// WEBPACK FOOTER //
// ./src/state/modules/comps/mutations.js